import { AddtoFlowEventFloatWrapper } from '@src/pages/livelens/FlowEventModal/styled';
import { Button } from 'antd';
import React from 'react';

const FloatBtn = ({
  event,
  onCreateEvent,
}: {
  event: { eventName: string; eventAttributes: Record<string, string> };
  onCreateEvent: (v: any) => void;
}) => {
  return (
    <AddtoFlowEventFloatWrapper>
      <div style={{ padding: '8px', marginTop: '-16px' }}>
        <Button type="primary" ghost onClick={() => onCreateEvent({ type: 'create', ...event })}>
          Create Event
        </Button>
      </div>
    </AddtoFlowEventFloatWrapper>
  );
};

export default React.memo(FloatBtn);
